module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent3"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm05"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v("Copyright © 2000 by Candace Bushnell")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, or the facilitation thereof, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review. Any members of educational institutions wishing to photocopy part or all of the work for classroom use, or publishers who would like to obtain permission to include the work in an anthology, should send their inquiries to Grove/Atlantic, Inc., 841 Broadway, New York, NY 10003.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('em', [_vm._v("Published simultaneously in Canada"), _c('br'), _vm._v("Printed in the United States of America")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_vm._v(" This is a work of fiction. Any resemblance to actual persons, living or dead, is purely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data"), _c('br'), _vm._v("Bushnell, Candace.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Four Blondes / Candace Bushnell.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("      p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("ISBN 0-8021-3825-X (pbk.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("1. Single women—Fiction. 2. Man-woman relationships—Fiction. 3. Dating (Social customs)—Fiction. 4. City and town life—Fiction. 5. New York (N.Y.)—Fiction. 6. Sex customs—Fiction. I. Title. PS3552.U8229 F68 2000")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("813’.54—dc21                                               00-042026")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_vm._v("Design by Laura Hammond Hough")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_vm._v("Grove Press"), _c('br'), _vm._v("an imprint of Grove/Atlantic, Inc."), _c('br'), _vm._v("841 Broadway"), _c('br'), _vm._v("New York, NY 10003"), _c('br'), _vm._v("Distributed by Publishers Group West")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.groveatlantic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.groveatlantic.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_vm._v("08 09 10 11 12     23 22 21 20 19 18 17 16")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-322f22f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm05.vue
// module id = 75
// module chunks = 0